<template>
  <div class="nav" :class="{ 'nav-solid' : isNavSolid }">
    <router-link to="/" class="nav-logo">
      <img src="../assets/img/logo_white.png" alt="ALEX TAXI">
    </router-link>
    <div class="nav-menu">
      <router-link class="nav-menu-item" exact-active-class="nav-menu-item-active" to="/">HOME</router-link>
      <router-link
        class="nav-menu-item"
        exact-active-class="nav-menu-item-active"
        to="/prices"
      >PRICES</router-link>
      <router-link
        class="nav-menu-item"
        exact-active-class="nav-menu-item-active"
        to="/booking"
      >ONLINE BOOKING</router-link>
      <router-link
        class="nav-menu-item"
        exact-active-class="nav-menu-item-active"
        to="/contacts"
      >CONTACTS</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isNavSolid: false
    };
  },
  methods: {
    isScrolled(event) {
      if (window.scrollY > 0) {
        this.isNavSolid = true;
      } else {
        this.isNavSolid = false;
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.isScrolled);
  },
  destroyed() {
    document.removeEventListener("scroll", this.isScrolled);
  }
};
</script>

<style scoped>
.nav {
  align-items: center;
  background-color: transparent;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding: 0 40px;
  position: fixed;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
  z-index: 1;
}
.nav-solid {
  background-color: rgba(0, 0, 0, 0.9);
}
.nav-menu-item {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  margin-right: 20px;
  position: relative;
}
.nav-menu-item:last-child {
  margin-right: 0;
}
.nav-menu-item:hover {
  color: #fdd55b;
}
.nav-menu-item-active::before {
  background-color: #fdd55b;
  bottom: -4px;
  content: "";
  left: 0;
  height: 4px;
  position: absolute;
  width: 100%;
}
@media screen and (max-width: 800px) {
  .nav {
    align-items: center;
    flex-direction: column;
    height: 80px;
    justify-content: center;
    padding: 0 20px;
  }
  .nav-logo {
    display: block;
    height: 40px;
    margin-bottom: 6px;
    width: auto;
  }
  .nav-logo img {
    height: 100%;
  }
  .nav-menu-item {
    font-size: 14px;
  }
}
@media screen and (max-width: 400px) {
  .nav-menu {
    display: flex;
  }
  .nav-menu-item {
    font-size: 12px;
    margin-right: 10px;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue